import { InitOptions } from 'i18next'

export const I18N_DEFAULT_NS = 'translation'
export const I18N_FALLBACK_LANGUAGE = 'en'

export default {
	supportedLngs: ['en'],
	fallbackLng: I18N_FALLBACK_LANGUAGE,
	defaultNS: I18N_DEFAULT_NS
} satisfies InitOptions
